import React, { PureComponent } from "react";
import Menu from "material-ui/Menu";
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import Icons from "customComponents/icons";
import Common from "../../constants/common";

export default class extends PureComponent {
    componentDidMount() {
        window.addEventListener("keydown", this.escKeyHandler);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.escKeyHandler);
    }

    handleRequestCloseHandler = () => {
        const { handleRequestClose } = this.props;
        handleRequestClose();
    };

    escKeyHandler = e => {
        if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
            e.preventDefault();
            this.handleRequestCloseHandler();
        }
    };

    render() {
        const { handleRequestClose, messages, containerDisplayName, ...rest } = this.props;
        const msg = messages.map(msgEle => (
            <div key={Common.uniqId()} className="message-list-item">
                <Icons
                    size="mini"
                    type={
                        ["W", "w"].includes(msgEle.notification)
                            ? "softblock-fill"
                            : "hardblock-fill"
                    }
                    customIconStyle={{ marginTop: "2px" }}
                    className={`alert-message ${
                        ["W", "w"].includes(msgEle.notification) ? "pending" : "failure"
                    }`}
                />
                <div className="padding-l-10">{msgEle.message}</div>
            </div>
        ));
        const conDisplayName = (containerDisplayName || "").toLowerCase();

        return (
            <Popover animation={PopoverAnimationVertical} {...rest} className="customPolicyMsg">
                <Menu>
                    <div className="Rectangle">
                        <div className="Violations-on-the inline-block">
                            {`${messages.length} ${
                                messages.length > 1 ? "Violations" : "Violation"
                            } on `}
                            <span style={{ textTransform: "capitalize" }}>{conDisplayName}</span>
                        </div>
                        <div className="cross-button inline-block">
                            <Icons
                                type="cross"
                                size="micro"
                                interactive
                                onClick={this.handleRequestCloseHandler}
                            />
                        </div>
                    </div>
                    <div className="message-list">{msg}</div>
                </Menu>
            </Popover>
        );
    }
}
